import { useState } from 'react';
import { addMonths, subMonths, addWeeks, subWeeks } from 'date-fns';

function useNavigation() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [leftAnimation, setLeftAnimation] = useState(false);
  const [rightAnimation, setRightAnimation] = useState(false);

  const nextMonth = () => {
    setCurrentDate(addMonths(currentDate, 1));
    setRightAnimation(true);
  };
  const prevMonth = () => {
    setCurrentDate(subMonths(currentDate, 1));
    setLeftAnimation(true);
  };
  const nextWeek = () => {
    setCurrentDate(addWeeks(currentDate, 1));
    setRightAnimation(true);
  };
  const prevWeek = () => {
    setCurrentDate(subWeeks(currentDate, 1));
    setLeftAnimation(true);
  };

  return {
    nextMonth,
    prevMonth,
    nextWeek,
    prevWeek,
    leftAnimation,
    rightAnimation,
    currentDate,
    setCurrentDate,
    setLeftAnimation,
    setRightAnimation,
  };
}

export default useNavigation;
